import { gql } from '@apollo/client';

export const createThreadItems = gql`
    mutation CreateThreadItems(
      $listId: Int!, 
      $host: String!,
      $content: String!,
      $type: String,
      $startDate: String,
      $endDate: String,
      $personCapacity: Int
    ){
        CreateThreadItems(
          listId: $listId,
          host: $host,
          content: $content,
          type: $type,
          startDate: $startDate,
          endDate: $endDate,
          personCapacity: $personCapacity
        ) {
            id
            threadId
            sentBy
            content
            type
            startDate
            endDate
            personCapacity
            createdAt
            status
        }
    }
`;

export const countQuery = gql`
    query getUnreadCount{
      getUnreadCount {
        hostCount
        guestCount
        total
      }
    }
    `;

export const UnreadThreadsQuery = gql`
    query getUnreadThreads{
      getUnreadThreads {
        id
        threadItemUnread {
          id
          threadId
          content
          sentBy
          isRead
          type
          createdAt
          startDate
          endDate
          personCapacity
        }
      }
    }
    `;

export const InboxQuery = gql`
    query GetAllThreads($threadType: String, $threadId: Int){
      GetAllThreads(threadType: $threadType, threadId: $threadId) {
        threadsData {
          id
          listId
          guest
          listData {
            city
            state
            country
          }
          threadItem {
            id
            threadId
            content
            sentBy
            isRead
            type
            startDate
            endDate
            createdAt
          }
          guestProfile {
            profileId
            displayName
            picture
          }
          hostProfile {
            profileId
            displayName
            picture
          }
          status
        }
        count
      }
    }
    `;

export const readMessage = gql`
    mutation readMessage($threadId: Int!){
        readMessage(threadId: $threadId) {
          status
            }
          }
    `;

export const ThreadItemsQuery = gql`
    query getThread($threadType: String, $threadId: Int) {
  getThread(threadType: $threadType, threadId: $threadId) {
    id
    listId
    guest
    host
    listData {
      title
      city
      state
      country
      isPublished
      listApprovalStatus
      listingData {
        basePrice
        cleaningPrice
        currency
        monthlyDiscount
        weeklyDiscount
      }
    }
    threadItemForType {
      id
      threadId
      reservationId
      content
      sentBy
      type
      startDate
      endDate
      personCapacity
      createdAt
      cancelData {
        id
        reservationId
        cancellationPolicy
        guestServiceFee
        hostServiceFee
        refundToGuest
        payoutToHost
        total
        currency
      }
      reservation {
        id
        listId
        hostId
        guestId
        checkIn
        checkOut
        basePrice
        cleaningPrice
        taxPrice
        taxValue
        total
        currency
        guests
        confirmationCode
        guestServiceFee
        discount
        discountType
        createdAt
        updatedAt
        hostServiceFee
        bookingSpecialPricing {
          id
          reservationId
          blockedDates
          isSpecialPrice
        }
        taxRate
      }
    }
    threadItems {
      id
      threadId
      reservationId
      content
      sentBy
      type
      startDate
      endDate
      createdAt
    }
    threadItemsCount
    guestProfile {
      profileId
      displayName
      firstName
      picture
      location
      reviewsCount
      userVerification {
        id
        isEmailConfirmed
        isFacebookConnected
        isGoogleConnected
        isIdVerification
      }
    }
    guestUserData {
      email
      userBanStatus
    }
    hostProfile {
      profileId
      displayName
      firstName
      picture
      location
      reviewsCount
      userVerification {
        id
        isEmailConfirmed
        isFacebookConnected
        isGoogleConnected
        isIdVerification
      }
    }
    hostUserData {
      email
    }
    status
  }
}`;

export const sendMessage = gql`
    mutation sendMessage(
    $threadId: Int!, 
    $content: String, 
    $type: String,
    $startDate: String,
    $endDate: String,
    $personCapacity: Int,
    $reservationId: Int
    ) {
      sendMessage(
      threadId: $threadId, 
      content: $content, 
      type: $type,
      startDate: $startDate,
      endDate: $endDate,
      personCapacity: $personCapacity,
      reservationId: $reservationId
      ){
        id
        sentBy
        content
        type
        reservationId
        startDate
        endDate
        personCapacity
        createdAt
        status
      }
    }
    `;